import { render } from "./ActivateAccount.vue?vue&type=template&id=23834922&scoped=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=23834922&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23834922"]])

export default __exports__